import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { PaneContainer } from "~/components/FileStatusTrackingPane/PaneContainer";
import { ZippingTaskCompletedPanelItem } from "./ZippingTaskCompletedPanelItem";
import { ZippingTaskFailedPanelItem } from "./ZippingTaskFailedPanelItem";
import { ZippingTaskInProgressPanelItem } from "./ZippingTaskInProgressPanelItem";
export const ZippingTasksPanel = /*#__PURE__*/ memo((param)=>{
    let { zippingTasks, onCancel, onClear, onHandleExpiredLink } = param;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "ZIPPING_TASK_PANEL",
        children: zippingTasks.map((zipping)=>{
            return /*#__PURE__*/ _jsx(PaneContainer, {
                className: "mb-2 last:mb-0",
                children: zipping.status === "in-progress" ? /*#__PURE__*/ _jsx(ZippingTaskInProgressPanelItem, {
                    onCancel: ()=>onCancel(zipping.localTaskId),
                    ...zipping
                }) : zipping.status === "completed" ? /*#__PURE__*/ _jsx(ZippingTaskCompletedPanelItem, {
                    onHandleExpiredLink: ()=>onHandleExpiredLink(zipping.remoteTaskId),
                    onClear: ()=>onClear(zipping.localTaskId),
                    ...zipping
                }) : /*#__PURE__*/ _jsx(ZippingTaskFailedPanelItem, {
                    onClear: ()=>onClear(zipping.localTaskId),
                    ...zipping
                })
            }, zipping.localTaskId);
        })
    });
});
ZippingTasksPanel.displayName = "ZippingFilesPanel";
